var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passedSuccess-box"},[_vm._m(0),_c('SharePop',{attrs:{"show":_vm.showPop},on:{"change":_vm.handlePopChange}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-flex-col u-col-center passedSuccess-item"},[_c('img',{staticClass:"icon-success",attrs:{"src":require("../assets/images/icon_submit_success.png")}}),_c('div',{staticClass:"carLoanSuccess-tit"},[_vm._v("初审通过注意接听电话")])])
}]

export { render, staticRenderFns }